export interface CompanyFormProfile {
  id?: number
  name: string
  shortName: string
  companyTypes: string[]
  alternativeNames: string[]
  taxId?: string | null
  phoneNumber?: string | null
  email?: string | null
  remarks?: string | null
  isDeactivated: boolean
  addressLine1?: string | null
  addressLine2?: string | null
  city?: string | null
  postalCode?: string | null
  country?: string | null
  accountInfo?: string | null
}

export const defaultValues: CompanyFormProfile = {
  name: '',
  shortName: '',
  companyTypes: [],
  alternativeNames: [''],
  taxId: '',
  phoneNumber: '',
  email: '',
  remarks: '',
  isDeactivated: false,
  addressLine1: '',
  addressLine2: '',
  city: '',
  postalCode: '',
  country: '',
  accountInfo: '',
}
